import React from "react";
import Router from "./routes";
import ThemeProvider from "./theme";
import { IconButton, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ScrollToTop from "./components/ScrollToTop";
import { SnackbarProvider } from "notistack";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/css/style.css";
import "simplebar/src/simplebar.css";
import Authorized from "./components/Authorized";

export default function App() {
  const notiStackRef = React.useRef(null);

  const onClickDismiss = (key) => () => {
    if (notiStackRef.current) {
      notiStackRef.current.closeSnackbar(key);
    }
  };

  return (
    <ThemeProvider>
      <ScrollToTop />
      <SnackbarProvider
        hideIconVariant
        ref={notiStackRef}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        TransitionComponent={Slide}
        maxSnack={3}
        autoHideDuration={2000}
        action={(key) => (
          <IconButton onClick={onClickDismiss(key)}>
            <CloseIcon htmlColor="white" />
          </IconButton>
        )}
      >
        <Authorized />
        <Router />
      </SnackbarProvider>
    </ThemeProvider>
  );
}
